import React from 'react';
import TransactionsIncomeManagement from "../income/TransactionsIncomeManagement";

const TransactionIncomeTab = () => {
    return (
        <>
            <TransactionsIncomeManagement />
        </>
    );
};

export default TransactionIncomeTab;
